import React, { useMemo } from 'react';
import useOrganizationGroups from '../../../../../hooks/api/useOrganizationGroups';
import { OrganizationTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import { RouteProp } from '@react-navigation/native';
import EditOrganizationUserFields, {
    FormValue,
    formValuesToUpdateOrganizationUserArgs,
    getInitialValues,
} from '../../../../shared/OrganizationUsers/EditOrganizationUserFields';
import { Form } from '../../../../v2BaseComponents/Form';
import { handleFormikSubmit } from '../../../../../utils/handleFormikSubmit';
import useOrganizationUsers from '../../../../../hooks/api/useOrganizationUsers';
import { useIsOrganizationOwner } from '../../../../../hooks/api/useOrganization';

export type EditUserScreenOwnProps = {};

export type EditUserScreenProps = EditUserScreenOwnProps & {
    route: RouteProp<OrganizationTabParamList, 'edit-user'>;
};

const EditUserScreen: React.FC<EditUserScreenProps> = (props) => {
    const goBack = useGoBack();
    const { isLoadingUser, user, updateUser, isUpdatingUser, userGroups, isLoadingUserGroups } = useOrganizationUsers({
        organizationUserId: props.route.params.organizationUserId,
        onUpdateUser: goBack,
    });
    const isOrganizationOwner = useIsOrganizationOwner();
    const { groups, isLoadingGroups } = useOrganizationGroups({});
    const isLoading = isLoadingUser || isUpdatingUser || isLoadingGroups || isLoadingGroups || isLoadingUserGroups;
    const isDisabled = useIsDisabledByParent(isLoading);

    const formValues = useMemo<FormValue>(
        () => getInitialValues({ user, userGroups, groups }),
        [groups, user, userGroups],
    );
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <Form
                    fillContainer
                    actionContainerSubmit
                    initialValues={formValues}
                    onSubmit={(values, helpers) => {
                        updateUser(
                            formValuesToUpdateOrganizationUserArgs({
                                organizationUserId: props.route.params.organizationUserId,
                                values,
                                user: user!,
                                userGroups,
                                isUpdatingUserOrganizationOwner: isOrganizationOwner,
                            }),
                        );
                        handleFormikSubmit(values, helpers);
                    }}
                    isDisabled={isDisabled}
                    onCancel={goBack}
                >
                    {({ values }) => <EditOrganizationUserFields initialValues={formValues} values={values} />}
                </Form>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditUserScreen);
